import React, { useContext } from 'react';
import { GlobalSiteDataContext } from '../context';
import {
  AboutLHR,
  ExclusiveDivider,
  HomeHeroVideo,
  TreatmentsDivider,
  WhyMilan,
  LHRSpecials,
  FiveStarsDivider,
  OurMetroDescription,
  SEO,
  LargestLHRBadge,
} from '../components';
import { graphql } from 'gatsby';
import './home.css';
// import { groups } from "../utils";

export default function HomePage() {
  const siteData = useContext(GlobalSiteDataContext);
  return (
    <main id='home-page'>
      <HomeHeroVideo />
      <LargestLHRBadge />
      <AboutLHR currentMetro={siteData.currentMetro} />
      <ExclusiveDivider />
      <WhyMilan />
      <TreatmentsDivider siteData={siteData} />
      <LHRSpecials />
      <FiveStarsDivider currentMetro={siteData.currentMetro} />
      <OurMetroDescription siteData={siteData} />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Laser Hair Removal in ${query.name}, ${query.stateAbbrev} | Milan Laser Hair Removal`}
      description={`Say hello to flawless skin with Milan Laser Hair Removal, the premier laser hair removal company in the United States. Book today to experience the ultimate in hair-free confidence.`}
    >
      <meta
        name='google-site-verification'
        content={query.google_verification ? query.google_verification : ''}
      />
    </SEO>
  );
};

export const query = graphql`
  {
    siteDataJson {
      google_verification
      name
      stateAbbrev
      state
      origin
    }
  }
`;
